import { getPeriodType } from './get_period_type'

export const formValuesToServerData = (values) => ({
  period_type: getPeriodType(values.periodType, values.movingType),
  start_date: values.startDate,
  end_date: values.endDate,
  max_booking_time: values.maxBookingTime ? Math.floor(values.maxBookingTime) * 24 * 60 : null
})
